module.exports = __webpack_public_path__ + "img/clogo18.12ab08ff.png";